import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { getActiveWargameConfig } from '@gamecodex/wargame-config'
import { TopNav } from './TopNav'
import { Footer } from './Footer'
import { bootstrapSession } from '@/lib/auth/atlasAuthClient'

export function RootLayout() {
  const storeEnabled = getActiveWargameConfig().store?.enabled
  // Silently restore a signed-in session (httpOnly refresh cookie) only when
  // this site actually has a store — no reason to hit /api/accounts on a
  // site with no checkout to attach a session to.
  useEffect(() => {
    if (storeEnabled) void bootstrapSession()
  }, [storeEnabled])

  return (
    <div className="flex min-h-screen flex-col bg-[#0a0a0c] text-white">
      <TopNav />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  )
}
